import styled from 'styled-components'
import { Sizes, Colors, FontLight, Breakpoints } from './../../utils/variables'

export const Container = styled.div`
    width: 100%;
    max-width: ${Sizes.maxContainerWidth};

    margin: 0 auto 30px auto;
    padding: 0 30px;

    @media screen and (min-width: ${Breakpoints.wide}) {
        margin: 0 auto 70px auto;
        padding: 0;
    }
`

export const Title = styled.h3`
    width: 100%;
    max-width: ${Sizes.maxContentWidth};

    margin: 0 auto 30px auto;

    ${FontLight}
    font-size: 30px;
    line-height: 40px;
    letter-spacing: -0.5px;
    color: ${Colors.blue};

    text-transform: uppercase;

    @media screen and (min-width: ${Breakpoints.wide}) {
        margin: 0 auto 50px auto;

        font-size: 65px;
        line-height: 70px;
    }
`

export const List = styled.ul`
    width: 100%;

    @media screen and (min-width: ${Breakpoints.wide}) {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 20px;
    }
`